import { ASSET_PATHS } from '../../utils/assetPath';

/**
 * EnterIcon component displays an enter/return key icon.
 *
 * @param className - Optional CSS class name to apply custom styling
 * @param size - Icon size in pixels (default: 16)
 * @param ariaLabel - Accessible label for screen readers (default: 'Enter')
 */
interface EnterIconProps {
  className?: string;
  size?: number;
  ariaLabel?: string;
}

export function EnterIcon({ className = '', size = 16, ariaLabel = 'Enter' }: EnterIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`enter-icon ${className}`.trim()}
      height={size}
      src={ASSET_PATHS.ENTER_ICON}
      width={size}
    />
  );
}

export default EnterIcon;
